import {
  GET_ESTIMATED_TIME_DISTANCE,
  GET_INSTALLATION_DETAIL,
  GET_INSTALLED_STATS,
  GET_INTIMATION_DOC_TYPES,
  GET_RTO,
  GET_VEHICLE_TYPES,
} from "../actions/types";

const initialState = { InstalledDevices: [], getEstimatedTimeDistance: [] };

const installedDetailedReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_INSTALLATION_DETAIL:
      return {
        ...state,
        InstalledDevices: payload,
      };
    case GET_INSTALLED_STATS:
      return {
        ...state,
        InstalledDeviceStats: payload,
      };
    case GET_VEHICLE_TYPES:
      return {
        ...state,
        vehicleTypes: payload,
      };
    case GET_RTO:
      return {
        ...state,
        rto: payload,
      };
    case GET_INTIMATION_DOC_TYPES:
      return {
        ...state,
        docTypes: payload,
      };
    case GET_ESTIMATED_TIME_DISTANCE:
      return {
        ...state,
        getEstimatedTimeDistance: payload,
      };

    default:
      return state;
  }
};

export { installedDetailedReducer };
